import React from 'react';
import { Icon, notification } from 'antd';
import classNames from 'classnames';

import { Typography } from 'app/components/common/typography';
import { ReactComponent as SuccessImage } from 'app/resources/success.svg';
import { ReactComponent as ErrorImage } from 'app/resources/error.svg';
import { ReactComponent as CloseImage } from 'app/resources/close.svg';
import { i18n } from 'app/i18n';

import styles from './notification.module.scss';

interface Props {
    text: string;
    className?: string;
    icon: React.FC;
    altText: string;
}

const openNotification = (props: Props) => {
    const { text, className, icon, altText } = props;

    return notification.open({
        message: (
            <Typography variant="body1" component="div" className={styles.text}>
                {text}
            </Typography>
        ),
        className: classNames(styles.notification, className),
        icon: <Icon component={icon} title={altText} className={styles.icon} />,
        closeIcon: <Icon component={CloseImage} title={i18n.image.close} className={styles.close} />,
    });
};

export const openSuccessNotification = (text: string) => {
    openNotification({
        text,
        className: styles.success,
        icon: SuccessImage,
        altText: i18n.image.success,
    });
};

export const openErrorNotification = (text: string) => {
    openNotification({
        text,
        className: styles.error,
        icon: ErrorImage,
        altText: i18n.image.error,
    });
};
